import {
    LegalEntityDiscountListQuery,
    LegalEntityDiscountListResponse,
    LegalEntityDiscountData,
    LegalEntityDiscountCreationParams,
    LegalEntityDiscountUpdateParams,
} from 'chaika-frontend-types/frontend-cms';
import { axios } from '@lib/axios';

const BASE_URL = '/api/legal-entity-discount';

export class LegalEntityDiscountApi {
    public static async get(id: string): Promise<LegalEntityDiscountData> {
        const res = await axios.get<LegalEntityDiscountData>(`${BASE_URL}/${id}`);

        return res.data;
    }

    public static async find(params?: LegalEntityDiscountListQuery): Promise<LegalEntityDiscountListResponse> {
        const res = await axios.get<LegalEntityDiscountListResponse>(BASE_URL, { params });
        return res.data;
    }

    public static async update(id: string, legalEntityDiscount: LegalEntityDiscountUpdateParams): Promise<void> {
        await axios.put(`${BASE_URL}/${id}`, { legalEntityDiscount });
    }

    public static async create(legalEntityDiscount: LegalEntityDiscountCreationParams): Promise<void> {
        await axios.post(BASE_URL, { legalEntityDiscount });
    }

    public static async delete(id: string): Promise<void> {
        await axios.delete(`${BASE_URL}/${id}`);
    }
}
